// Страницы, перенесённые из старого Office (smremont). Каждый раздел — свой файл в этой папке:
//   export const pages = { officeWhLots: "/office/warehouse/lots" };      // ключ = menu_action в admin.menu_tab
//   export const routes = [{ path: "/office/warehouse/lots", name: "officeWhLots",
//                            meta: { layout: "main", title: "Склад: приходы" },
//                            component: () => import("@/views/office/warehouse/Lots.vue") }];
// pages подмешиваются в PAGES (src/constants), routes — в роутер. Файлы подхватываются сами.
const ctx = require.context("./", false, /^\.\/(?!index\.js$)[\w-]+\.js$/);

export const officePages = {};
export const officeRoutes = [];

ctx.keys().forEach((key) => {
  const mod = ctx(key);
  Object.assign(officePages, mod.pages || {});
  officeRoutes.push(...(mod.routes || []));
});
